import { docTabs } from './pnp-docs/pnp-docs.tabs';
import { settingsTabs } from './pnp-settings/pnp-settings.tabs';

export const tabs = {...settingsTabs,...docTabs};
